import {FormControl} from "@angular/forms";

export function moreThenZero(c: FormControl) {
    return Number(c.value) > 0 ? null : {
        message: 'lta-errors.moreThenZero'
    };
}
